import JQueryView, { on } from '../../../common/views/jqueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    // 初期表示クラス
    $('input, select, textarea').each(function () {
      const $el = $(this);
      if ($el.val() !== '' && !$el.hasClass('is-invalid')) {
        $el.addClass('is-activated');
      }
    });
  }

  @on({ event: 'change', selector: 'input,select,textarea' })
  onChangeInputStyle(e: JQuery.TriggeredEvent) {
    const $el = $(e.currentTarget);

    if ($el.val() === '') {
      $el.removeClass('is-activated');
    } else {
      $el.addClass('is-activated').removeClass('is-invalid');

      $el.parents('.form-group').find('.invalid-feedback').hide();
    }
  }

  @on({ event: 'change', selector: '.js-contact-file' })
  onChangeContactFile(e: JQuery.ChangeEvent<HTMLInputElement>) {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];

      $('.file-name').show().text(file.name);
      $('.file-delete').show();
      $('.free_contact_filename').addClass('free_contact_filesend');
    }
  }

  @on({ event: 'click', selector: '.js-concat-file-delete' })
  onClickContactFileDelete() {
    // ファイルの選択をリセット
    $('.js-contact-file').val('');

    $('.file-name').hide();
    $('.file-delete').hide();
    $('.free_contact_filename').removeClass('free_contact_filesend');
  }
}
